import React, { useEffect, useContext, useRef, useState } from 'react';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Col, Form, Input, Row, Space, Switch } from 'antd';
import MembershipTransactionDetailsEx from './MembershipTransactionDetailsEx';
import MembershipPointsDetails from './MembershipPointsDetails';
import { SocketContext } from '../../../App';
import BindPhysicalCardToMembership from './BindPhysicalCardToMembership';

const Membership = (props: any) => {
   const [modalVisibleBindPhysicalCardToMembership, setModalVisibleBindPhysicalCardToMembership] = useState<boolean>(false);
    const ref = useRef<any>(undefined);
    const [modalVisibleMembershipTransactionDetails, setmodalVisibleMembershipTransactionDetails] = useState<boolean>(false);
    const [modalVisibleMembershipPointsDetails, setModalVisibleModalVisibleMembershipPointsDetails] = useState<boolean>(false);
    const [membershipRechargeBillsData, setMembershipRechargeBillsData] = useState<any>();
    const [form] = Form.useForm();
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;
    // let contactNumber = form.getFieldValue("contactNumber");
    /** api服务id */
    const apiId = 'membership';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }
        fetchData();
        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据
    const onRefresh = (item: any) => {

        const { branchStoreId } = item
        const currentData: initDataType = {
            apiId,
            sendPageData: { branchStoreId }
        }

        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }
    const columnsHead = [

        {
            title: '姓名',
            dataIndex: 'membershipInfo',
            render: (val: any) => val.membershipName
        },
        {
            title: '联系电话',
            dataIndex: 'membershipInfo',
            render: (val: any) => val.contactNumber
        },
        {
            title: '余额',
            dataIndex: 'balance',
            sorter: true
        },
        {
            title: '赠送',
            dataIndex: 'gifts',
            sorter: true
        },
        {
            title: '积分',
            dataIndex: 'points',
            sorter: true
        },
        {
            title: '类别',
            dataIndex: 'membershipType',
            render: (val: any) => val?.typeName
        },
        {
            title: '模式',
            dataIndex: 'membershipMode',
            render: (val: any) => val?.name
        },
        {
            title: '允许退款',
            dataIndex: 'isAllowRefunds',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                    onChange={(e) => ref.current.handleChangeOne(record.id, 'isAllowRefunds', e, 'membership')}
                />
            )
        },
        {
            title: '交易明细',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setMembershipRechargeBillsData({
                                membershipId: val
                            })
                            setmodalVisibleMembershipTransactionDetails(true);
                        }}>{'交易明细'}</Button>
                    </Space>
                </>
            )
        },
        {
            title: '积分明细',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setMembershipRechargeBillsData({
                                membershipId: val
                            })
                            setModalVisibleModalVisibleMembershipPointsDetails(true);
                        }}>{'积分明细'}</Button>
                    </Space>
                </>
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '会员',
        apiId,
        columns,

        showStates: true,
        pagination: true,
        showAdd: false,
        showDelete: false,
        showEdit: false,
        // EditComponent: PayDetailsEdit,
        sendPageData: { branchStoreId: contextData?.currentBranchStoreId }
    };
    // const changeContactNumber = (e:any) => {
    //     let value=e.target.value;
         
    //     const currentData: initDataType = {
    //         apiId,
    //         sendPageData: { contactNumber:value, branchStoreId: contextData?.currentBranchStoreId }
    //     }
    //     ref.current.initData(currentData);
    // }
    return (
        <>
         <Button type='primary' onClick={() => {
                setModalVisibleBindPhysicalCardToMembership(true);
            }}>绑定会员实体卡</Button>
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ width: "70%" }}>
                    <Form form={form} >
                        <Row>

                            <Col span={8}>
                                <Form.Item
                                    label="手机号码"
                                    name="contactNumber"

                                >
                                    <Input onKeyDown={(e: any) => {
                                        if (e.key === 'Enter') {
                                            changeContactNumber(e)
                                        }
                                    }} />
                                </Form.Item>
                            </Col>

                        </Row>
                    </Form>


                </div>

            </div> */}
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
            {modalVisibleMembershipTransactionDetails ?
                (<MembershipTransactionDetailsEx
                    closeModal={() => setmodalVisibleMembershipTransactionDetails(false)}
                    data={membershipRechargeBillsData} />)
                : null}
            {modalVisibleMembershipPointsDetails ?
                (<MembershipPointsDetails
                    closeModal={() => setModalVisibleModalVisibleMembershipPointsDetails(false)}
                    data={membershipRechargeBillsData} />)
                : null}
              {modalVisibleBindPhysicalCardToMembership ?
                (<BindPhysicalCardToMembership
                    closeModal={() => setModalVisibleBindPhysicalCardToMembership(false)} />)
                : null}
            {/* {modalVisibleMembershipPointsDetails ?
                (<MembershipPointsDetails
                    closeModal={() => setmodalVisibleModalVisibleMembershipPointsDetails(false)}
                    data={membershipRechargeBillsData} />)
                : null} */}
        </>
    )
}

export default Membership